import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild, OnDestroy  } from '@angular/core';
import { forkJoin, scheduled, asyncScheduler, of} from 'rxjs';
import { BaseDataService, ConfigService, ConfirmationDialogButtons, ModalService, QueryParameter, UserRightsService } from 'yt-ng-framework';
import { List } from 'immutable';
import { Chart } from './chart';
import { UserProvajderView } from 'src/app/admin/orgjeddefgini/userprovajder/userprovajder-view';
import { concatMap, delay, map } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Media, ButtonMedia } from 'yt-ng-framework';
import { Route, Router } from '@angular/router';
import { VERSION } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


interface Request {
  status: string;
  variable: string;
}

interface Result {
  variable: string;
  count: number;
}

const statusi: Request[] = [
  {status: "Approved", variable: 'rnOdobrenih'},
  {status: "Sent", variable: 'rnPoslatih'},
  {status: "Rejected", variable: 'rnOdbijenih'},
  {status: "Draft", variable: 'rnNacrta'},
  {status: "Storno", variable: 'rnStorno'}
];

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy  {

  constructor(
    protected baseDataService: BaseDataService,
    protected userRightsService: UserRightsService,
    protected configService: ConfigService,
    protected modalService: ModalService,
    protected sanitizer: DomSanitizer,
    protected router: Router,
    protected changeDetectorRef: ChangeDetectorRef,
    
  ) { }

  dataSource: List<List<any>> = List([List([])]);
  hasUserRights: boolean;
  hasUserSeeSetup: boolean;
  rnOdobrenih:number=0;
  rnPoslatih:number=0;
  rnOdbijenih:number=0;
  rnNacrta:number=0;
  rnStorno: number=0;
  apiUrl: string;
  database: string;
  response:any;
  provajder: string;
  provajderSEO: string;
  angularVerzija : string = VERSION.full;

  showTutorial: boolean = false; 
  videoDescription: string;
  videoUrl: string;
  button1Text: string;
  button2Text: string;

  private destroy$ = new Subject<void>();

  ngOnInit() {

    setTimeout(() => {
      this.hasUserRights = this.userRightsService.GetUserRightValue('homepage',"see_DiagramOnFirstPage");
      this.hasUserSeeSetup = this.userRightsService.GetUserRightValue('homepage',"see_Setup");
    }, 1000)
    
    forkJoin([
      this.baseDataService.Get('charts', 'fakturisanoPoMesecima', null, Chart, null),
      this.baseDataService.Get('charts', 'troskoviPoMesecima', null, Chart, null),
      this.baseDataService.Get('charts', 'izvodiDugujePoMesecima', null, Chart, null),
      this.baseDataService.Get('charts', 'izvodiPotrazujePoMesecima', null, Chart, null)
    ])
    .pipe(takeUntil(this.destroy$)) // Otkazivanje subskripcije na destroy$
    .subscribe(data => {
      this.dataSource = this.dataSource.clear();
      this.dataSource = this.dataSource.push(List(data[0]));
      this.dataSource = this.dataSource.push(List(data[1]));
      this.dataSource = this.dataSource.push(List(data[2]));
      this.dataSource = this.dataSource.push(List(data[3]));
    })

    
    this.proveraPoStatusima();

    this.configService.GetApiUrlAsync()
    .subscribe(result => {
      this.apiUrl = result
    }
    )
    
    this.baseDataService.Get(
      'Setup'
      , 'GetDatabase'
      , null
      , null
    )
    .subscribe((result : any) =>{
      this.database= result;
    })

    this.baseDataService.Get(
      'Userprovajder'
      , 'GetByUserIDAndCompanyID'
      , null
      , UserProvajderView
    )
    .subscribe((result) =>{
      if (result)
      {
        this.response = result;
        this.provajder = this.response[0].Provajder;
        this.provajderSEO = this.response[0].EOtprProvajder;
      }
      else
      {
        this.provajder ="Nepoznat";
        this.provajderSEO = "Nepoznat"
      }
    })

    this.getVideoPreference();
    this.proveriVelicinuEkrana();
   // this.loadVideoDescriptions();
  }

  ngOnDestroy() {
    if (this.screenSizeTimeout) {
      clearTimeout(this.screenSizeTimeout);
    }

    // Emitovanje signala za otkazivanje subskripcija
    this.destroy$.next();
    this.destroy$.complete();
  }

  proveraPoStatusima(){   

    // delay(index * 1000), // Dodaje zadršku od 1 sekunde između zahteva    
    //delay(index), // Dodaje zadršku od 1 sekunde između zahteva

    scheduled(statusi, asyncScheduler).pipe(
      concatMap((req, index) =>
        of(req).pipe(
          delay(index+1000), // Dodaje zadršku od 1 sekunde između zahteva
          concatMap(req =>
            this.baseDataService.Get(
              'FakDokument',
              'GetNumberOfDocsByStatus',
              [new QueryParameter("docStatus", req.status)],
              null
            ).pipe(
              map((result: any): Result => ({
                variable: req.variable, 
                count: Number(result)
              }))
              ,takeUntil(this.destroy$)
            )
          )
        )
      )
    ).subscribe((result: Result) => {
      this[result.variable] = result.count;
    });
   
  }

  private screenSizeTimeout: any;

  private proveriVelicinuEkrana() {
    if (window.innerWidth < 1024 && !localStorage.getItem('prikazanoObavestenje')) {
//      setTimeout(() => {
        this.screenSizeTimeout = setTimeout(() => {
          this.modalService.ShowConfirmationDialog(
          "Obaveštenje",
          "Za najbolje iskustvo, molimo koristite desktop računar na adresi: erp.yuteam.co.rs",
          "warning",
          ConfirmationDialogButtons.Ok
        );
        localStorage.setItem('prikazanoObavestenje', 'true');
      }, 0);
    }
  }

  media = new Media();
  buttons:  ButtonMedia[];
  safeVideoUrl: SafeResourceUrl;
  safeImageUrl: SafeResourceUrl;
  videoAvailable: boolean = false;
  getVideoPreference() {
    this.baseDataService.Get('Media', 'getByUserId', null, Media)
    .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => { 
        if(data){
          this.media = data;
          if (this.media.VideoId) {
            this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${this.media.VideoId}`);
            this.videoAvailable = true;
            this.showTutorial = this.media.PrikaziTutorijal;
        } else {
            this.safeImageUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/video-u-pripremi.png'); 
            this.videoAvailable = false;
            this.showTutorial = this.media.PrikaziTutorijal;
        }        
          if(this.media.MediaInfoId){
          this.baseDataService.Get('Media', 'GetButtonsForMediaInfo', [new QueryParameter('mediaInfoId', this.media.MediaInfoId)] , ButtonMedia)
            .subscribe(buttonsData =>{
              this.buttons = buttonsData;
            })
          }
        }
        // this.getVideoDetails(data.videoId); 
      }, error => {
        console.error('Došlo je do greške pri dohvatanju video preference', error);
      });
  }

  buttonClick(url){
    this.router.navigateByUrl(url);
  }


  toggleTutorial() {

    this.modalService.ShowConfirmationDialog(
      "Obaveštenje",
      "Da li ste sigurni da želite da sklonite tutorijal?",
      "question",
      ConfirmationDialogButtons.YesNo
    ).result.then((result) => {
        if (result) {
          this.showTutorial = !this.showTutorial;
          this.baseDataService.Get('Media', 'SkloniTutorijal', [new QueryParameter('mediaInfoId',this.media.MediaInfoId)], null)
          .subscribe(()=>{
            //this.notificationsService.success('Uspešno', 'Sačuvan');
          });
        }
    });
  }

  getBrojRacuna(): number {
    return [this.rnOdobrenih, this.rnPoslatih, this.rnOdbijenih, this.rnNacrta, this.rnStorno]
      .filter(v => v > 0)
      .reduce((sum, v) => sum + v, 0);
  }
  

}
